import React from "react";
import { Modal, Form, Input, Card } from "antd";
import Button from "./button";
import colors from "../../share/constants/constants";

const PasswordModal = ({ onCancel, onOk, text, title, promo }) => {
  const [form] = Form.useForm();
  return (
    <div>
      <Modal
        open={true}
        footer={null}
        closeIcon={null}
        className="space-y-8"
        width="479px"
        onCancel={onCancel}
      >
        <h3>{title}</h3>
        <p>{text}</p>
        <p>{promo}</p>
        <Card className="border-2 p-2">
          <Form form={form}>
            <div className="grid grid-cols-1 ">
              <Form.Item name="newpass" className="w-full">
                <Input
                  placeholder={"New Password"}
                  className={"w-full h-5.4"}
                />
              </Form.Item>
              <Form.Item name="confirmPass">
                <Input
                  className="flex items-center w-full h-5.4"
                  placeholder="Confirm Password"
                />
              </Form.Item>
              <Form.Item className="flex justify-end">
                <Button
                  title={"Save"}
                  color={colors.primaryBlue}
                  htmlType="submit"
                  //   onClick={onOk}
                  className="w-15"
                />
              </Form.Item>
            </div>
          </Form>
        </Card>
      </Modal>
    </div>
  );
};
export default PasswordModal;
